type Props = {
  id: string
  idClassName?: string
}

export const IdLayout = ({ id, idClassName }: Props) => {
  return (
    <div className="flex flex-col items-end md:max-w-full">
      <span className="text-text-secondary">ID:</span>
      <span
        className={`text-primary dark:text-primary-dark font-klein font-medium ${idClassName} max-w-[100px] truncate`}
      >
        {id}
      </span>
    </div>
  )
}
